import moment from 'moment';
import dayjs from 'dayjs';

class Util {
    static dateToText = (date, format) => {
        let dateFormat = format;
        if ((format == null) || (format == undefined)) {
            dateFormat = 'YYYY-MM-DD HH:mm:ss';
        }
        return moment(date).format(dateFormat);
    }
    static separateThousands = (text) => {
        var result = "";
        if ((text != null) && (text != undefined) && (text != 'undefined')) {
            let minus = false;
            if ((text + '').length > 1) {
                if ((text + '').charAt(0) == '-') {
                    minus = true;
                }
            }
            var newText = (text + '').replace(/,/g, "").replace(/-/g, "");
            for (var i = 1; i <= newText.length; i++) {
                result = newText.charAt(newText.length - i) + result;
                if (i % 3 == 0 && i != newText.length) {
                    result = "," + result;
                }
            }
            if (minus) {
                result = '-' + result;
            }
        }
        return result;
    }
    static toNumber = (text) => {
        let number = text * 1;
        return number;
    }
    static toText = (number) => {
        let text = number + '';
        return text;
    }
    static lpad = (text, padString, length) => { // 숫자 앞에 0 붙이기
        let str = '' + text;
        while (str.length < length) {
            str = padString + str;
        }
        return str;
    }
    static itemStyle = (condition, name, color) => {
        if (condition) {
            return name + ':' + color;
        }
        else {
            return '';
        }
    }
    static textValue = (text) => {
        if (text != null) return text;
        else return "";
    }
    static numberValue = (number) => {
        if (number != null) return number;
        else return 0;
    }
    static getShortened = (text, maxLength) => {
        let result = text + '';
        if (text.length > maxLength) {
            result = text.slice(0, maxLength) + '..';
        }
        return result;
    }
    static isEmpty = (text) => {
        if ((text == undefined) || (typeof text == "undefined") || (text == null) || (text.length == 0)) {
            return true;
        }
        else {
            return false;
        }
    }
    static isNotEmpty = (text) => {
        if ((text == undefined) || (typeof text == "undefined") || (text == null) || (text.length == 0)) {
            return false;
        }
        else {
            return true;
        }
    }
    static isSameDate = (date1, date2) => {
        if (Number(date1) == Number(date2)) {
            return true;
        }
        else {
            return false;
        }
    }
    // static getPhoneText = (text) => {
    //     var result = "";
    //     if ((text != undefined) && (text != 'undefined')) {
    //         var newText = (text + '').replace(/-/g, "");
    //         newText = newText.replace(/ /g, "");
    //         for (var i = 1; i <= newText.length; i++) {
    //             result = newText.charAt(newText.length - i) + result;
    //             if (i % 4 == 0 && i != newText.length) {
    //                 result = "-" + result;
    //             }
    //         }
    //     }
    //     return result;
    // }
    static getPhoneText = (text) => {
        if (!text || text === 'undefined') return "";
        if (text.length < 5) return text;

        let result = "";
        let prefix = "";
        let newText = text + "";

        // 국제전화코드 부분 추출 (예: (+62))
        const intlMatch = newText.match(/^\(\+\d+\)/);
        if (intlMatch) {
            prefix = intlMatch[0];  // "(+62)"
            newText = newText.replace(prefix, ""); // 나머지 번호만 추출
        }

        // 숫자와 공백, 하이픈 제거
        newText = newText.replace(/[-\s]/g, "");

        // 전화번호 뒤에서부터 4자리씩 끊기
        for (let i = 1; i <= newText.length; i++) {
            result = newText.charAt(newText.length - i) + result;
            if (i % 4 === 0 && i !== newText.length) {
                result = "-" + result;
            }
        }

        // 국제전화 코드가 있으면 붙여서 반환
        if (prefix) {
            result = `${prefix} ${result}`;
        }

        return result;
    }

    static getTelPhoneText = (text) => {
        let result = '';
        if ((text != undefined) && (text != 'undefined')) {
            let phoneNumber = text + '';
            let phone1 = '';
            let phone2 = '';
            let phone3 = '';
            if (phoneNumber.startsWith('02')) {
                // phone1: 앞 2자리, phone3: 뒤 4자리, phone2: 나머지
                phone1 = phoneNumber.slice(0, 2);
                phone2 = phoneNumber.slice(2, phoneNumber.length - 4);
                phone3 = phoneNumber.slice(phoneNumber.length - 4);
            } else {
                let areaCodes = ['02', '031', '032', '033', '041', '042', '043', '044', '051', '052', '053', '054', '055', '061', '062', '063', '064'];
                let areaCode = phoneNumber.slice(0, 3);
                if (areaCodes.includes(areaCode)) {
                    // phone1: 앞 3자리, phone3: 뒤 4자리, phone2: 나머지
                    phone1 = phoneNumber.slice(0, 3);
                    phone2 = phoneNumber.slice(3, phoneNumber.length - 4);
                    phone3 = phoneNumber.slice(phoneNumber.length - 4);
                } else {
                    // 4자리씩 구분
                    let phoneNumbers = this.getPhoneText(phoneNumber).split('-');
                    if (phoneNumbers.length > 2) {
                        phone1 = phoneNumbers[0];
                        phone2 = phoneNumbers[1];
                        phone3 = phoneNumbers[2];
                    }
                    else if (phoneNumbers.length == 2) {
                        phone1 = phoneNumbers[0];
                        phone2 = phoneNumbers[1];
                    }
                    else if (phoneNumbers.length == 1) {
                        phone1 = phoneNumbers[0];
                    }
                }
            }
            if (phone1.length > 0) {
                result += phone1;
            }
            if (phone2.length > 0) {
                result += '-' + phone2;
            }
            if (phone3.length > 0) {
                result += '-' + phone3;
            }
        }
        return result;
    }
    static onInput = (text, object, regExp, maxLength, nextFocus, onMessage) => {
        var result = text + '';
        if (regExp != null) {
            var matched = result.match(regExp);
            if (matched != null) {
                let matchedText = '';
                for (let i = 0; i < matched.length; i++) {
                    matchedText += matched[i];
                }
                result = matchedText;
            }
            else {
                result = '';
            }
            if (result.length != text.length) {
                if (onMessage != null) {
                    onMessage(text);
                }
            }
        }
        if (maxLength != null) {
            result = result.substring(0, maxLength);
        }
        object.lazyValue = result;
        if (nextFocus != null) {
            if (result.length == maxLength) {
                nextFocus.focus();
            }
        }
        return result;
    }
    static getSecondsDiff = (startDate, endDate) => {
        const msInSecond = 1000;
        return Math.round(
            Math.abs(endDate - startDate) / msInSecond
        );
    }
    static getResidentNumber = (text) => {
        let numbers = '';
        if ((text != undefined) && (text != 'undefined')) {
            if (text.length > 6) {
                numbers = text.substring(0, 6);
                numbers += '-*******';
            }
        }
        return numbers;
    }
    static toInt = (number) => {
        return parseInt((number * 1) + '');
    }
    static isNewItem = (item) => {
        return ((item.id == undefined) || (item.id == null));
    }
    // 날짜 범위 계산
    static getDateRange = (range) => {
        const now = dayjs();
        let startDate;
        let endDate = now;

        switch (range) {
            case "thisMonth":
                startDate = now.startOf("month");
                break;

            case "lastMonth":
                const last = now.subtract(1, "month");
                startDate = last.startOf("month");
                endDate = last.endOf("month");
                break;

            case "3months":
                startDate = now.subtract(3, "month").startOf("month");
                break;

            case "6months":
                startDate = now.subtract(6, "month").startOf("month");
                break;

            case "all":
                startDate = dayjs("2000-01-01");
                break;

            default:
                startDate = now;
        }

        return { startDate, endDate };
    };
}

export default Util;